import { render, staticRenderFns } from "./SubtaskForm.vue?vue&type=template&id=6cef2c5d"
import script from "./SubtaskForm.vue?vue&type=script&lang=js"
export * from "./SubtaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports